import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import DataTable from "react-data-table-component";
import { toast } from "react-toastify";
import { withdrawService } from "../../services/WithdrawalServices";

const WithdrawalList = () => {
  const [withdrawals, setWithdrawals] = useState([]);
  const [filteredWithdrawals, setFilteredWithdrawals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");

  useEffect(() => {
    fetchWithdrawals();
  }, []);

  useEffect(() => {
    const filtered = withdrawals.filter((withdrawal) =>
      withdrawal.username?.toLowerCase().includes(search.toLowerCase()) ||
      withdrawal.email?.toLowerCase().includes(search.toLowerCase()) ||
      withdrawal.withdrawal_request?.toLowerCase().includes(search.toLowerCase())
    );
    setFilteredWithdrawals(filtered);
  }, [search, withdrawals]);

  const fetchWithdrawals = async () => {
    try {
      const response = await withdrawService.withdrawalList();
      if (response.status === 200) {
        const data = response.data?.data || [];
        setWithdrawals(data);
        setFilteredWithdrawals(data);
      } else {
        toast.error(response?.data?.message || "Failed to fetch data");
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Something went wrong!");
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB"); // Format: DD/MM/YYYY
  };

  const columns = [
    {
      name: "S. No.",
      selector: (row, index) => index + 1,
      sortable: true,
    },
    {
      name: "User Name",
      selector: (row) => row.username,
      sortable: true,
    },
    {
      name: "Email",
      selector: (row) => row.email,
      sortable: true,
    },
    {
      name: "Wallet Address",
      selector: (row) => row.wallet_address,
      sortable: true,
    },
    {
      name: "Phone No.",
      selector: (row) => row.phoneNumber,
      sortable: true,
    },
    {
      name: "Withdrawal ID",
      selector: (row) => row.withdrawal_request,
      sortable: true,
    },
    {
      name: "Amount",
      selector: (row) => row.amount,
      sortable: true,
    },
    {
      name: "Request Date",
      selector: (row) => formatDate(row.createdAt),
      sortable: true,
    },
    {
      name: "Status",
      cell: (row) => {
        const badgeClass = {
          pending: "bg-warning",
          approved: "bg-success",
          rejected: "bg-danger",
        }[row.status] || "bg-secondary";

        return <span className={`badge ${badgeClass}`}>{row.status}</span>;
      },
      sortable: true,
    },
    {
      name: "Actions",
      cell: (row) => (
        <div className="btn-group" role="group">
          <Link
            to={`/admin/withdrawal/view/${row._id}`}
            className="btn btn-outline-info"
          >
            <i className="icofont-eye text-info"></i>
          </Link>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  return (
    <div className="body d-flex py-3">
      <div className="container-xxl">
        <div className="row align-items-center">
          <div className="border-0 mb-4">
            <div className="card-header py-3 no-bg bg-transparent d-flex align-items-center px-0 justify-content-between border-bottom flex-wrap">
              <h3 className="fw-bold mb-0">Withdrawal List</h3>
            </div>
          </div>
        </div>
        <div className="row align-item-center">
          <div className="col-md-12">
            <div className="card mb-3">
              <div className="card-header py-3 bg-transparent border-bottom-0 d-flex justify-content-between">
                <h6 className="mb-0 fw-bold">Withdrawals</h6>
              </div>
              <div className="card-body">
                <div className="row mb-3">
                  <div className="col-md-4">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search by name, email, or withdrawal ID"
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                    />
                  </div>
                </div>
                {loading ? (
                  <p>Loading withdrawal list...</p>
                ) : (
                  <DataTable
                    columns={columns}
                    data={filteredWithdrawals}
                    pagination
                    highlightOnHover
                    noDataComponent="No records found"
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WithdrawalList;
